import React, {Fragment} from 'react';
import _ from 'lodash';
import Notice from '../../../../components/Notification/newNotification';
import {connect} from "react-redux";
import ViewHeader from '../view-header';
import ReactTooltip from 'react-tooltip';
import {Button} from 'reactstrap';
import ModalComponent from '../../../../components/Modal/';
import DentistInfo from '../../../../components/Dentists/DentistInfo';
import DentistRegistrationForm from '../../../../components/DentistRegistrationForm/index';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { globals } from '../../../../../../common/constants';
import '../../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Pagination from "rc-pagination";
import {
    addUser,
    getUsers,
    editUser,
    deleteUser,
    getDentistInfo,
    changeUserStatus,
    generateResetPasswordLink
} from "./actions";

//Icons
import IconSpinner from 'react-icons/lib/fa/spinner';
import {Link} from "react-router-dom";
import { getCustomFilter } from '../../../../components/CustomInput'
import { scrollTo, defaultToEmptyString } from "../../../../helpers";

// Helpers
import {
    validateRequired,
    validateEmail,
    validatePassword,
    getDefaultFilters
} from './helpers';
import {getPatients} from "../Patients/actions";

class Users extends React.Component {
    constructor (props) {
        super(props);
        let locationState = this.props.history.location.state;
        const locationStateDefaults = getDefaultFilters();
        locationState = _.assign(locationStateDefaults, locationState);
        this.state = {
            option: {
                noDataText: 'No dentist is available yet.',
                onPageChange: (page) => this.handlePageChange(page),
                hideSizePerPage: true,
                sizePerPage: globals.dentistsPerPage,
                onSortChange: (field, order) => this.changeSortingOptions(field, order),
                page: locationState.pageNumber,
                expandBodyClass: "tr-opened",
                onExpand: (rowId, isExpand) => {
                    if (isExpand) {
                        return this.setState({ selectedRowId: rowId });
                    }
                    this.setState({ selectedRowId: null });
                }
            },
            deleteModal: false,
            dentistInfoModal: false,
            dentistName: '',
            deletedElementId: 0,
            addUserModal: false,
            openEditModal: false,
            statuses: {
                active : 'active',
                inactive : 'inactive',
                rejected : 'rejected',
                unavailable : 'unavailable',
                archived: 'archived'
            },
            info: {},
            user: {
                id: null,
                email: '',
                first_name: '',
                last_name: '',
                username: '',
                password: '',
                confirm_password: '',
                confirm_email: ''
            },
            errors: {
                title: 'Something went wrong.',
                message: 'Please try again later.',
                level: 'error',
                show: undefined
            },
            validation: {
                email: { message: ''},
                first_name: { message: ''},
                last_name: {message: ''},
                password: {message: ''},
                username: {message: ''},
                confirm_password: {message: ''},
                confirm_email: {message: ''},
            },
            registerButtonDisable: false,
            createdBy: '',
            filterData: {
                filterOptions: locationState.filterData.filterOptions,
                sortingOptions: locationState.filterData.sortingOptions
            },
            selectedRowId: null,
            focusedField: null
        };
    }

    componentDidMount () {
        document.title = "Dentist List";
        const page = this.state.option.page;
        const { filterOptions, sortingOptions } = this.state.filterData;
        this.props.getDentists(page, filterOptions, sortingOptions);
        this.props.getPatients(page, filterOptions, sortingOptions);
        this.interval = setInterval(() => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDentists(page, filterOptions, sortingOptions);
        }, 7000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleClose() {
        this.setState({
            addNewPatient: false,
            info: {},
            dentistInfoModal: false,
            deleteModal: false,
            cancelModal: false,
            validateNewPatient: {
                first_name: true,
                last_name: true,
            },
            createdBy: ''
        });
        
    }

    handleBlur(key, value) {
        let validationObject = this.validations(key, value);
        this.setState({
            validation: validationObject,
        })
    }

    validations = (key, value) => {
        const specialKeys = ['username'];
        const validationObject = this.state.validation;
        let validation;
        if (specialKeys.indexOf(key) >= 0) {
            switch (key) {
                case 'email':
                    validation = validateEmail(value);
                    validationObject.email = {
                        valid: validation,
                        message: (!validation) ? 'Please enter a valid email.' : ''
                    }
                    break;
                case 'password':
                    validation = validatePassword(value);
                    validationObject.password = {
                        valid: validation,
                        message: (!validation) ? 'Password must be at least 6 characters.' : ''
                    }
                    break;
                case 'confirm_password':
                    if(this.state.user.password !== value){
                        validationObject.confirm_password = {
                            valid: false,
                            message: 'Your passwords do not match. Please try again.'
                        }
                    } else {
                        validationObject.confirm_password = {
                            valid: true,
                            message: ''
                        }
                    }

                    break;
                case 'confirm_email':
                    if(this.state.user.email !== value){
                        validationObject.confirm_email = {
                            valid: false,
                            message: 'Your Email do not match. Please try again.'
                        }
                    } else {
                        validationObject.confirm_email = {
                            valid: true,
                            message: ''
                        }
                    }

                    break;
                case 'username':
                    validationObject.password = {
                        valid: true,
                        message: ''
                    }
                    break;
                default: break;
            }
        } else {
            validation = validateRequired(value);
            validationObject[key] = {
                valid: validation,
                message: (!validation) ? 'This field is required.' : ''
            }

        }
        return validationObject;
    }

    handleChange = (key, value) => {
        const validationObject = this.state.validation;
        let validation;
        switch (key) {
            case 'email':
                validation = validateEmail(value);
                validationObject.email = {
                    valid: validation,
                    message: (!validation) ? 'Please enter a valid email.' : ''
                }
                if(this.state.user.confirm_email !== value){
                    validationObject.confirm_email = {
                        valid: false,
                        message: 'Your email do not match. Please try again.'
                    }
                }
                break;
            case 'password':
                validation = validatePassword(value);
                validationObject.password = {
                    valid: validation,
                    message: (!validation) ? 'Password must be at least 6 characters.' : ''
                }
                if(this.state.user.confirm_password !== value){
                    validationObject.confirm_password = {
                        valid: false,
                        message: 'Your passwords do not match. Please try again.'
                    }
                }
                break;
            case 'confirm_password':
                if(this.state.user.password !== value){
                    validationObject.confirm_password = {
                        valid: false,
                        message: 'Your passwords do not match. Please try again.'
                    }
                }
                else {
                    validationObject.confirm_password = {
                        valid: true,
                        message: ''
                    }
                }
                break;

            case 'confirm_email':
                if(this.state.user.email !== value){
                    validationObject.confirm_email = {
                        valid: false,
                        message: 'Your passwords do not match. Please try again.'
                    }
                }
                else {
                    validationObject.confirm_email = {
                        valid: true,
                        message: ''
                    }
                }
                break;
            case 'first_name':
                validation = validateRequired(value);
                validationObject.first_name = {
                    valid: validation,
                    message: (!validation) ? 'This field is required.' : ''
                }
                break;
            case 'last_name':
                validation = validateRequired(value);
                validationObject.last_name = {
                    valid: validation,
                    message: (!validation) ? 'This field is required.' : ''
                }
                break;
            case 'username':
                validationObject.username = {
                    valid: true,
                    message: ''
                }
                break;
            default: break;
        }
        let notValid = false;
        for (const i of Object.keys(validationObject)) {
            if (validationObject[i].valid === undefined || !validationObject[i].valid) {
                notValid = true;
                break;
            }
        }
        let count = 0;
        Object.keys(validationObject).forEach(obj => {
            if(validationObject[obj].valid || validationObject[obj].valid===undefined){
                count++;
            }
        });
        if(count === 5) {
            notValid = false;
        }
        const {user} = this.state;
        user[key] = value;
        if(!user.last_name || !user.first_name) {
            notValid = true;
        }
        this.setErrorMessageStatus();
        this.setState({user, validation: validationObject});
    }

    handleSubmit = () => {
        const validation = this.state.validation;
        const {user} = this.state;
        Object.keys(user).forEach(item => {
            this.validations(item, user[item]);
        });
        if(!validation.email.message && !validation.first_name.message && !validation.last_name.message && !validation.password.message && !validation.username.message && validation.email && !validation.confirm_email.message && validation.confirm_password && !validation.confirm_password.message) {
            this.props.createUser({user: {...user, license: defaultToEmptyString(user.license) }});
        } else {
            this.setState({validation});
        }
    }

    handleSubmitEdit = () => {
        var {user} = this.state;
        const validation = this.state.validation;
        Object.keys(user).forEach(item => {
            this.validations(item, user[item]);
        });
        if(!validation.email.message && !validation.first_name.message && !validation.last_name.message && !validation.password.message && !validation.username.message) {
            this.props.editUser({user});
        } else {
            this.setState({validation});
        }
    }

    setErrorMessageStatus = (status = false) => {
        var object = this.state.errors;
        object['show'] = status;
        this.setState({
            errors: object
        })
    }

    openMoreInfo = (event, row) => {
        this.setState({
            dentistInfoModal: true,
            dentistName: `${row.first_name} ${row.last_name}`,
            info: row
        })
    }

    openEditModal = (event, row, createdBy) => {
        this.setState({
            openEditModal: true,
            user: Object.assign(this.state.user, {id: row.id, email: row.email, first_name: row.first_name, last_name: row.last_name , username: row.username, license: row.license}),
            validation: {first_name: { valid: true, message : ''}, last_name: { valid: true,message : ''}, email: { message : ''}, password: { message : ''}, confirm_password: { message : ''},confirm_email: { message : ''}, username: { message : ''}},
            registerButtonDisable: false,
            info: row,
            createdBy: createdBy
        })
    }

    closeEditModal = () => {
        this.setState({
            openEditModal: false,
            registerButtonDisable: false,
            user: {email: '', first_name: '', last_name: '', username: '', password: '', id: null}
        })
    }

    onGenerateResetPasswordLink = (event, { email }) => {
        if (!email) {
            Notice.addNotification('Dentist have no email address. Please add the email address to his profile.', 'error');
            return;
        }
        this.props.generateResetPasswordLink(email);
    }

    ActionFormatter = (cell,row) => {
        const disableDelete = this.props.patientsList.find((patient)=> patient.dentist_id === row.id)
        switch (row.status) {
            case 'active':
                return (
                    <div>
                        <button data-tip="Inactive" className={"btn active"} onClick={(event) => this.onChangeStatus(event, row.id, 'inactive')}>
                            <span className="kr kr-check" />
                        </button>
                        <button  data-tip="Dentists who have active cases, cannot be deleted." className={"btn"}
                                 onClick={disableDelete ? ()=>{} : (event) => this.onDeleteDentistModal(event, row.id)}>
                            <span className={disableDelete ? "kr kr-delete disable_delete_opacity" : "kr kr-delete"} />
                        </button>
                        <ReactTooltip place="top" type="light" effect="float" />
                        <button data-tip="Generate Reset Password link" className={"btn"} onClick={(event) => this.onGenerateResetPasswordLink(event, row)}>
                            <span className="kr kr-unhold" />
                        </button>
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            case 'inactive':
                return (
                    <div>
                        <button data-tip="Active" className={"btn inactive"} onClick={(event) => this.onChangeStatus(event, row.id, 'active')}>
                            <span className="kr kr-check" />
                        </button>
                        <button data-tip="Delete Profile" className={"btn"} onClick={(event) => this.onDeleteDentistModal(event, row.id)}>
                            <span className="kr kr-delete" />
                        </button>
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            case 'pending':
                return (
                    <div>
                        <button data-tip="Approve" className={"btn pending"} onClick={(event) => this.onChangeStatus(event, row.id, 'active')}>
                            <span className="kr kr-pending" />
                        </button>
                        <button data-tip="Rejected" className={"btn"} onClick={(event) => this.onChangeStatus(event, row.id, 'rejected')}>
                            <span className="kr kr-close" />
                        </button>
                        <button data-tip="Delete Profile" className={"btn"} onClick={(event) => this.onDeleteDentistModal(event, row.id)}>
                            <span className="kr kr-delete" />
                        </button>
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            case 'rejected':
                return (
                    <div>
                        <button data-tip="Active" className={"btn rejected"} onClick={(event) => this.onChangeStatus(event, row.id, 'active')}>
                            <span className="kr close" />
                        </button>
                        <button data-tip="Delete Profile" className={"btn"} onClick={(event) => this.onDeleteDentistModal(event, row.id)}>
                            <span className="kr kr-delete" />
                        </button>
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            case 'unavailable':
                return (
                    <div>
                        <button data-tip="Delete Profile" className={"btn"} onClick={(event) => this.onDeleteDentistModal(event, row.id)}>
                            <span className="kr kr-delete" />
                        </button>
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            default: break;

        }
    }

    ViewProfileFormatter = (cell, row) => {
        if (row.status === 'archived') return;
        return (
            <div>
                <button data-tip="View Profile" className={"btn-fab btn btn-sm"} onClick={() => this.props.getDentistInfo(row.id)}>
                    <span className="kr kr-profile" />
                </button>
                <button data-tip="Edit Profile" className={"btn-fab btn btn-sm"} onClick={(event) => this.openEditModal(event, row, row.created_by)}>
                    <span className="kr kr-edit" />
                </button>
                <ReactTooltip place="top" type="light" effect="float" />
            </div>
        )
    }

    onDeleteDentistModal = (event, userId) => {
        event.stopPropagation();
        this.setState({deleteModal: true, deletedElementId: userId});
    }

    onChangeStatus = (event, userId, status) => {
        event.stopPropagation();
        this.props.changeDentistStatus(userId, status, this.state.option.page, this.state.filterData.filterOptions, this.state.filterData.sortingOptions)
    }

    onDeleteDentist = (userId) => {
        this.setState({deleteModal: false, deletedElementId: 0})
        this.props.deleteDentist(userId, this.state.option.page, this.state.filterData.filterOptions, this.state.filterData.sortingOptions);
    }

    openAddUserModal = () => {
        this.setState({
            addUserModal: !this.state.addUserModal, user: {
                id: null,
                email: '',
                first_name: '',
                last_name: '',
                username: '',
                password: ''
            },
            registerButtonDisable: false,
            validation: {
                email: { message: ''},
                first_name: { message: ''},
                last_name: {message: ''},
                password: {message: ''},
                confirm_password: {message: ''},
                confirm_email: {message: ''},
                username: {message: ''},
        }});
    }

    idFormatter = (row, cell) => {
        if (cell.created_by === "admin") {
            return  <div className="lab-admin" data-tip="Created by Lab Admin" data-for='lab_admin'>
                <span className="number">{row}</span>
                <span className="kr kr-by-admin" />
                <ReactTooltip id='lab_admin' place="right" type="light" effect="" />
            </div>
        }
        return row;
    }


    statusFormatter = (cell) => {
        if (cell === "pending") {
            return "Pending Approval"
        }
        return cell;
    }

    dentistFormatter = (cell, row) => {
        if (row.status === 'archived') return cell;
        return <Link 
                    className="link-item"
                    to={{
                        pathname: `/sm-admin/dentists/${row.id}`, 
                        state: {
                            page: '/sm-admin/dentists',
                            pageName: 'Dentist List', 
                            pageNumber: this.state.option.page, 
                            filterData: this.state.filterData, 
                            fromDentists: true
                        }
                    }}>{cell}</Link>
    }

    dentistArrow = () => {
        return <div>
            <span className="kr kr-arrow" />
        </div>
    }

    componentWillReceiveProps(nextProps) {
        const {addIsSuccess, editUser, deletedUser} = nextProps.dentists;
        if (addIsSuccess) {
            Notice.addNotification('Dentist is successfully added.', 'success');
            this.setState({addUserModal: false});
        } else if (editUser) {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDentists(page, filterOptions, sortingOptions);
            Notice.addNotification('Dentist is successfully updated.', 'success');
            this.setState({openEditModal: false});
        } else if (editUser === false) {
            if(!Object.values(nextProps.dentists.validation).filter(item => !item.message).length) {
                Notice.addNotification('Something went wrong.', 'error');
            }
            else {
                this.setState({validation: nextProps.dentists.validation});
            }
        } else if (addIsSuccess === false) {
            if(!Object.values(nextProps.dentists.validation).filter(item => !item.message).length) {
                Notice.addNotification('Something went wrong.', 'error');
            }
            else {
                this.setState({validation: nextProps.dentists.validation});
            }
        } else if (deletedUser === true) {
                Notice.addNotification('Dentist is successfully deleted.', 'success');
        } else if (deletedUser === false) {
                Notice.addNotification('Something went wrong while deleting dentist. Please try again later.', 'error');
        }
        const { loadingDentist, dentistInfo } = nextProps.dentists;
        if (!loadingDentist && this.props.dentists.loadingDentist) {
            this.setState({
                dentistInfoModal: true,
                dentistName: `${dentistInfo.first_name} ${dentistInfo.last_name}`,
                info: dentistInfo
            })
        }

        if (!nextProps.dentists.resetPasswordLinkLoading && this.props.dentists.resetPasswordLinkLoading) {
            if (nextProps.dentists.resetPasswordLinkSuccess) {
                Notice.addNotification('Password reset link is sent successful!', 'success');
            } else {
                Notice.addNotification('Something went wrong while generating password reset link', 'error');
            }
        }
        this.setErrorMessageStatus((addIsSuccess === false));
    }

    getFilterDefaultValue = (filterName) => {
        return this.state.filterData.filterOptions[filterName] || '';
    }

    changeFilterOptions = (field, value) => {
        if (field === 'id') {
            value = Number(value);
        } else {
            value = value.toLowerCase()
        }
        this.setState({
            filterData: {
                filterOptions: {
                    ...this.state.filterData.filterOptions,
                    [field]: value
                },
                sortingOptions: {
                    ...this.state.filterData.sortingOptions,
                }
            },
            option: {
                ...this.state.option,
                page: 1
            }
        }, () => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDentists(page, filterOptions, sortingOptions);
        });
    }

    handlePageChange = (page) => {
        scrollTo(0,'smooth');
        this.setState({
            option: {
                ...this.state.option,
                page
            }
        }, () => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDentists(page, filterOptions, sortingOptions);
        });
    }

    changeSortingOptions = (field, order) => {
        this.setState({
            filterData: {
                sortingOptions: {
                    [field]: order
                },
                filterOptions: {
                    ...this.state.filterData.filterOptions
                }
            },
            option: {
                ...this.state.option,
                page: 1
            }
        }, () => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getDentists(page, filterOptions, sortingOptions);
        });
    }

    trClassFormat = (rowData) => {
        return `dentist-table-cursor mb-table ${this.state.selectedRowId === rowData.id ? 'active-row' : ''}`;
    }

    setFocusedField = (fieldName) => {
        this.setState({ focusedField: fieldName });
    }

    render () {
        const header = 'DENTIST LIST';
        const desc = 'The list of all dentists';
        const navBig = document.body.clientWidth > globals.NAV_MIDDLE;
        const mobileTableRender = () => {
            return (
                <BootstrapTable
                    expandableRow={() => true}
                    className="dentist-mobile-table"
                    expandComponent={expandComponent}
                    ref={table => this.table = table}
                    data={this.props.dentists.dentistsList}
                    trClassName={ this.trClassFormat }
                    selectRow={this.state.selectRowProp}
                    options={this.state.option}
                    fetchInfo={{dataTotalSize: this.props.dentists.totalCount}}
                    expandByColumnOnly={true}
                    remote
                    responsive
                    striped
                    ignoreSinglePage
                >
                    <TableHeaderColumn
                        width="50"
                        isKey
                        dataField='id'
                        dataFormat={this.idFormatter}
                        dataSort={true}
                        sortFunc={() => 0}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            customFilterParameters: {
                                input_name: 'id',
                                focused: this.state.focusedField === 'id',
                                focus: this.setFocusedField,
                                activeClassName: 'active-field',
                                blur: () => this.setFocusedField(null),
                                placeholder: '',
                                defaultValue: this.getFilterDefaultValue('id'),
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="100"
                        dataField='first_name'
                        dataFormat={this.dentistFormatter}
                        dataSort={true}
                        sortFunc={() => 0}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            customFilterParameters: {
                                input_name: 'first_name',
                                focused: this.state.focusedField === 'first_name',
                                focus: this.setFocusedField,
                                activeClassName: 'active-field',
                                blur: () => this.setFocusedField(null),
                                placeholder: '',
                                defaultValue: this.getFilterDefaultValue('first_name'),
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        First Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="100"
                        dataField='last_name'
                        dataFormat={this.dentistFormatter}
                        dataSort={true}
                        sortFunc={() => 0}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            customFilterParameters: {
                                input_name: 'last_name',
                                focused: this.state.focusedField === 'last_name',
                                focus: this.setFocusedField,
                                activeClassName: 'active-field',
                                blur: () => this.setFocusedField(null),
                                placeholder: '',
                                defaultValue: this.getFilterDefaultValue('last_name'),
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        Last Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="30"
                        dataFormat={this.dentistArrow}
                    />
                </BootstrapTable>
            )
        }

        const expandComponent = (row) => {
            return <div className="tb-block table_drop_row">
                    <div className="tb-block__item">
                        <span>Email</span>
                        <span>{row.email}</span>
                    </div>
                    <div className="tb-block__item">
                        <span>Username</span>
                        <span>{row.username}</span>
                    </div>
                    <div className="tb-block__item">
                        <span>Added Date</span>
                        <span>{row.createdAt}</span>
                    </div>
                    <div className="tb-block__item">
                        <span>Status</span>
                        <span>{row.status}</span>
                    </div>
                    <div className="tb-block__action">
                        {this.ViewProfileFormatter(row,row)}
                        {this.ActionFormatter(row,row)}
                    </div>
                </div>
        }

        return (
            <div className="view">
                <ViewHeader
                    header={header}
                    desc={desc}
                    openModal={() => this.openAddUserModal()}
                    openConvertModal={() => this.setState({ addBookingShow: true })}
                    secondaryButtonName={'Add Dentist'}
                    showPrimary={false}
                    showSecondary={true}
                />
                <div className="view-content view-dashboard">
                    <div className="table-block">
                        <div>
                            {
                                (this.props.dentists.loading) ? <h1 className="text-center"><IconSpinner className="spinner"/> Loading...</h1> :
                                    <Fragment>
                                        {navBig ?
                                            <BootstrapTable
                                                search={false}
                                                ref={table => this.table = table}
                                                data={this.props.dentists.dentistsList}
                                                trClassName="dentist-table-cursor"
                                                selectRow={ this.state.selectRowProp }
                                                options={ this.state.option }
                                                fetchInfo={{ dataTotalSize: this.props.dentists.totalCount }}
                                                remote
                                                responsive
                                                striped
                                                ignoreSinglePage>
                                                <TableHeaderColumn
                                                    width="120"
                                                    isKey
                                                    dataField='id'
                                                    dataFormat={this.idFormatter}
                                                    dataSort={ true }
                                                    sortFunc={() => 0}
                                                    filter={{
                                                        type: 'CustomFilter',
                                                        getElement: getCustomFilter,
                                                        customFilterParameters: {
                                                            input_name: 'id',
                                                            placeholder: 'Search',
                                                            defaultValue: this.getFilterDefaultValue('id'),
                                                            changeFilterOptions: this.changeFilterOptions
                                                        }
                                                    }}>ID</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    width="148"
                                                    dataField='first_name'
                                                    dataFormat={this.dentistFormatter}
                                                    dataSort={ true }
                                                    sortFunc={() => 0}
                                                    filter={{
                                                        type: 'CustomFilter',
                                                        getElement: getCustomFilter,
                                                        customFilterParameters: {
                                                            input_name: 'first_name',
                                                            placeholder: 'Search',
                                                            defaultValue: this.getFilterDefaultValue('first_name'),
                                                            changeFilterOptions: this.changeFilterOptions
                                                        }
                                                    }}>First Name</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    width="148"
                                                    dataField='last_name'
                                                    dataFormat={this.dentistFormatter}
                                                    dataSort={ true }
                                                    sortFunc={() => 0}
                                                    filter={{
                                                        type: 'CustomFilter',
                                                        getElement: getCustomFilter,
                                                        customFilterParameters: {
                                                            input_name: 'last_name',
                                                            placeholder: 'Search',
                                                            defaultValue: this.getFilterDefaultValue('last_name'),
                                                            changeFilterOptions: this.changeFilterOptions
                                                        }
                                                    }}>Last Name</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    width="250"
                                                    dataField='email'
                                                    dataSort={true}
                                                    sortFunc={() => 0}
                                                    filter={{
                                                        type: 'CustomFilter',
                                                        getElement: getCustomFilter,
                                                        customFilterParameters: {
                                                            input_name: 'email',
                                                            placeholder: 'Search',
                                                            defaultValue: this.getFilterDefaultValue('email'),
                                                            changeFilterOptions: this.changeFilterOptions
                                                        }
                                                    }}>Email</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    width="148"
                                                    dataField='username'
                                                    dataSort={ true }
                                                    sortFunc={() => 0}
                                                    filter={{
                                                        type: 'CustomFilter',
                                                        getElement: getCustomFilter,
                                                        customFilterParameters: {
                                                            input_name: 'username',
                                                            placeholder: 'Search',
                                                            defaultValue: this.getFilterDefaultValue('username'),
                                                            changeFilterOptions: this.changeFilterOptions
                                                        }
                                                    }}>Username</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    dataField='createdAt'
                                                    width="160"
                                                    dataSort={ true }
                                                    sortFunc={() => 0}
                                                    filter={{
                                                        type: 'CustomFilter',
                                                        getElement: getCustomFilter,
                                                        customFilterParameters: {
                                                            input_name: 'createdAt',
                                                            type: 'date',
                                                            defaultValue: this.getFilterDefaultValue('createdAt'),
                                                            changeFilterOptions: this.changeFilterOptions
                                                        }
                                                    }}>Added Date</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    columnClassName={"td-status"}
                                                    width="150"
                                                    dataFormat={this.statusFormatter}
                                                    dataField='status'
                                                    dataSort={ true }
                                                    sortFunc={() => 0}
                                                    filter={{
                                                        type: 'CustomFilter',
                                                        getElement: getCustomFilter,
                                                        customFilterParameters: {
                                                            input_name: 'status',
                                                            placeholder: 'Select Status...',
                                                            type: 'select',
                                                            statuses: this.state.statuses,
                                                            defaultValue: this.getFilterDefaultValue('status'),
                                                            changeFilterOptions: this.changeFilterOptions
                                                        }
                                                    }}>Status</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    width="105"
                                                    dataField='action'
                                                    dataFormat={this.ActionFormatter}>Actions</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    width="95"
                                                    dataField='profile'
                                                    dataFormat={this.ViewProfileFormatter}>Profile</TableHeaderColumn>
                                            </BootstrapTable> : mobileTableRender()
                                        }
                                    </Fragment>
                            }
                            {
                                this.state.addUserModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle={`Add Dentist`}
                                    modalBody={
                                        <DentistRegistrationForm
                                            validation={this.state.validation}
                                            handleBlur={(key, value) => this.handleBlur(key, value)}
                                            handleChange={(key, value) => this.handleChange(key, value)}
                                            handleSubmit={() => this.handleSubmit()}
                                            registerButtonDisable={this.state.registerButtonDisable}
                                            user={this.state.user}
                                        />
                                    }
                                    show={this.state.addUserModal}
                                    handleClose={() => this.openAddUserModal()}
                                    buttonText="Create"
                                    buttonDisabled={this.state.registerButtonDisable}
                                    buttonStyle={(this.state.registerButtonDisable) ? 'no-shadow-btn btn-primary disabled' : 'no-shadow-btn btn-primary'}
                                    buttonFunction={() => this.handleSubmit()}
                                />
                            }
                            {
                                this.state.openEditModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle={`Edit Dentist Info`}
                                    modalBody={
                                        <DentistRegistrationForm
                                            validation={this.state.validation}
                                            handleBlur={(key, value) => this.handleBlur(key, value)}
                                            handleChange={(key, value) => this.handleChange(key, value)}
                                            handleSubmit={() => this.handleSubmitEdit()}
                                            registerButtonDisable={this.state.registerButtonDisable}
                                            user={this.state.user}
                                            createdBy={this.state.createdBy}
                                        />
                                    }
                                    show={this.state.openEditModal}
                                    handleClose={() => this.closeEditModal()}
                                    buttonText="Save"
                                    buttonStyle={(this.state.registerButtonDisable) ? 'no-shadow-btn btn-primary disabled' : 'no-shadow-btn btn-primary'}
                                    buttonFunction={() => this.handleSubmitEdit()}
                                    dialogClassName="edit-dentist-info"
                                />
                            }
                            {
                                this.state.deleteModal &&
                                    <ModalComponent
                                        modalHeaderStyle="modalHeaderDefault"
                                        headerTitle="Delete Dentist"
                                        modalBody="Are you sure you want to permanently delete the user?"
                                        show={this.state.deleteModal}
                                        handleClose={() => this.handleClose()}
                                        buttonText="Delete"
                                        buttonFunction={() => this.onDeleteDentist(this.state.deletedElementId)}
                                    />
                            }
                            {
                                this.state.dentistInfoModal &&
                                    <ModalComponent
                                        modalHeaderStyle="modalHeaderDefault"
                                        headerTitle={`Dentist ${this.state.dentistName}`}
                                        modalBody={
                                            <DentistInfo data={this.state.info} />
                                        }
                                        show={this.state.dentistInfoModal}
                                        handleClose={() => this.handleClose()}
                                        closeModal={true}
                                        dialogClassName="dentist-profile-dialog"
                                    />
                            }
                            <Pagination
                                locale={{ prev_page: 'prev', next_page: 'next'}}
                                className="pagination__rc"
                                showLessItems
                                hideOnSinglePage
                                onChange={this.state.option.onPageChange}
                                current={this.state.option.page}
                                total={this.props.dentists.totalCount}
                                pageSize={globals.dentistsPerPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ({
        dentists: state.dentists,
        allDentistsList: state.allDentistsList,
        patientsList: state.adminPatients.patientsList
    })
};

const mapDispatchToProps = dispatch => {
    return {
        getDentists: (page, filterOptions, sortingOptions) => dispatch(getUsers(page, filterOptions, sortingOptions)),
        deleteDentist: (userId, page, filterOptions, sortingOptions) => dispatch(deleteUser(userId, page, filterOptions, sortingOptions)),
        changeDentistStatus: (userId, status, page, filterOptions, sortingOptions) => dispatch(changeUserStatus(userId, status, page, filterOptions, sortingOptions)),
        createUser: (data) => dispatch(addUser(data)),
        editUser: (data) => dispatch(editUser(data)),
        getDentistInfo: id => dispatch(getDentistInfo(id)),
        getPatients: (page, filterOptions, sortingOptions) => dispatch(getPatients(page, filterOptions, sortingOptions)),
        generateResetPasswordLink: id => dispatch(generateResetPasswordLink(id))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Dentists/index.js